export const TAB_KEY = 'segment';
export const LAST_VISITED_SEGMENT_STORAGE_KEY = 'last-visited-segment-id';

export enum WRColumns {
  PatientDetails = 'patient-details',
  Practice = 'practice',
  PatientStatus = 'patient-status',
  ProviderDetails = 'provider-details',
  JoinTime = 'join-time',
  WaitTime = 'wait-time',
  VisitType = 'visit-type',
  ContactInfo = 'contact-info',
  VisitTime = 'visit-time',
  Actions = 'actions',
  Language = 'language',
  PatientLocation = 'patient-location',
  CompletedTime = 'visit_completed',
  CreatedTime = 'visit_created',
  SubmittedTime = 'visit_submitted',
  SignedTime = 'visit_signed',
  AddendumSignedAt = 'visit_addendum_signed',
  OpenText = 'cc_note_1',
  TimeInStatus = 'time_in_status',
  LastChatMessage = 'visit_chat_participant',
  ReasonForVisit = 'reason_for_visit',
  AudioToVideoTime = 'audio_to_video_time',
  CurrentEscalationLevel = 'current_escalation_level',
  ServiceLine = 'service_line',
  ProvenanceTileName = 'provenance_tile_name',
  ProvenanceModality = 'provenance_tile_modality',
}
